<section class="container p-0">
  <h1 i18n><span class="italic">Foro</span> Bhavani</h1>
</section>
<hr>
<div class="container forum">
  <div class="forum__actions">
    <a [routerLink]="['/platform/forum/new/.']" i18n class="forum__btn forum__btn--primary">Iniciar una nueva
      conversación</a>
  </div>
  <div *ngIf="forumsLoaded else loadingForums">
    <ul class="forum__list">
      <li class="forum__item" *ngFor="let forum of fixed_forums; let i = index">
        <div class="forum__post-grid" [routerLink]="['/platform/forum', forum.slug, '.']">
          <!-- Columna avatar -->
          <div class="forum__avatar-col">
            <img class="forum__avatar" [src]="forum.user?.avatar || 'default.jpg'" alt="Avatar" />
          </div>

          <!-- Columna de contenido -->
          <div class="forum__content-col">
            <div class="forum__row">
              <span class="forum__name">
                {{ forum.user?.name ? forum.user.name : forum.user?.initials }}
                <ng-container [ngSwitch]="forum.user?.bhavani_badge">
                  <span *ngSwitchCase="'BHAVANI_TEAM'" class="small">(Equipo BHAVANI)</span>
                  <span *ngSwitchCase="'BHAVANI_COACH'" class="small">(Coach BHAVANI)</span>
                </ng-container>
              </span>
              <span class="forum__time">{{ forum?.created_at | date:'short' }}</span>
            </div>

            <h2 class="forum__post-title">
              {{ lang == 'es' ? (forum.title || forum.title_en) : (forum.title_en || forum.title) }}
            </h2>

            <p class="forum__post-description">
              {{ lang == 'es' ? (forum.content_extract || forum.content_en_extract) : (forum.content_en_extract ||
              forum.content_extract) }}
            </p>

            <div class="forum__tags" *ngIf="forum?.tags?.length > 0">
              <ng-container *ngFor="let tag of forum.tags">
                <span class="tag" [ngClass]="{ 'tag--highlight': tag === 'Destacado' }">{{ tag }}</span>
              </ng-container>
            </div>

            <div class="forum__meta">
              <span class="forum__meta-item">
                <!-- Ícono corazón (likes) -->
                <svg class="forum__icon" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path
                    d="M13.8941 3.07357C13.5536 2.73291 13.1493 2.46267 12.7043 2.2783C12.2593 2.09392 11.7824 1.99902 11.3007 1.99902C10.8191 1.99902 10.3421 2.09392 9.89716 2.2783C9.45219 2.46267 9.0479 2.73291 8.7074 3.07357L8.00073 3.78024L7.29406 3.07357C6.60627 2.38578 5.67342 1.99938 4.70073 1.99938C3.72804 1.99938 2.79519 2.38578 2.1074 3.07357C1.4196 3.76137 1.0332 4.69422 1.0332 5.66691C1.0332 6.6396 1.4196 7.57245 2.1074 8.26024L8.00073 14.1536L13.8941 8.26024C14.2347 7.91974 14.505 7.51545 14.6893 7.07048C14.8737 6.6255 14.9686 6.14857 14.9686 5.66691C14.9686 5.18525 14.8737 4.70831 14.6893 4.26334C14.505 3.81836 14.2347 3.41408 13.8941 3.07357Z"
                    stroke="#332C26" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                {{ forum.likes_count || 0 }}
              </span>

              <span class="forum__meta-item">
                <!-- Ícono comentario (respuestas) -->
                <svg class="forum__icon" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path
                    d="M14 7.66669C14.0023 8.5466 13.7967 9.41461 13.4 10.2C12.9296 11.1412 12.2065 11.9328 11.3116 12.4862C10.4168 13.0396 9.3855 13.3329 8.33333 13.3334C7.45342 13.3356 6.58541 13.1301 5.8 12.7334L2 14L3.26667 10.2C2.86995 9.41461 2.66437 8.5466 2.66667 7.66669C2.66707 6.61452 2.96041 5.58325 3.51381 4.68839C4.06722 3.79352 4.85884 3.0704 5.8 2.60002C6.58541 2.20331 7.45342 1.99772 8.33333 2.00002H8.66667C10.0562 2.07668 11.3687 2.66319 12.3528 3.64726C13.3368 4.63132 13.9233 5.94379 14 7.33335V7.66669Z"
                    stroke="#332C26" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                {{ forum.comments_count || 0 }}
              </span>
            </div>

          </div>
        </div>
      </li>
      <li class="forum__item" *ngFor="let forum of forums; let i = index">
        <div class="forum__post-grid" [routerLink]="['/platform/forum', forum.slug, '.']">
          <!-- Columna avatar -->
          <div class="forum__avatar-col">
            <img class="forum__avatar" [src]="forum.user?.avatar || 'default.jpg'" alt="Avatar" />
          </div>

          <!-- Columna de contenido -->
          <div class="forum__content-col">
            <div class="forum__row">
              <span class="forum__name">
                {{ forum.user?.name ? forum.user.name : forum.user?.initials }}
                <ng-container [ngSwitch]="forum.user?.bhavani_badge">
                  <span *ngSwitchCase="'BHAVANI_TEAM'">(Equipo BHAVANI)</span>
                  <span *ngSwitchCase="'BHAVANI_COACH'">(Coach BHAVANI)</span>
                </ng-container>
              </span>
              <span class="forum__time">{{ forum?.created_at | date:'short' }}</span>
            </div>

            <h2 class="forum__post-title">
              {{ lang == 'es' ? (forum.title || forum.title_en) : (forum.title_en || forum.title) }}
            </h2>

            <p class="forum__post-description">
              {{ lang == 'es' ? (forum.content_extract || forum.content_en_extract) : (forum.content_en_extract ||
              forum.content_extract) }}
            </p>

            <div class="forum__tags" *ngIf="forum?.tags?.length > 0">
              <ng-container *ngFor="let tag of forum.tags">
                <span class="tag" [ngClass]="{ 'tag--highlight': tag === 'Destacado' }">{{ tag }}</span>
              </ng-container>
            </div>

            <div class="forum__meta">
              <span class="forum__meta-item">
                <!-- Ícono corazón (likes) -->
                <svg class="forum__icon" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path
                    d="M13.8941 3.07357C13.5536 2.73291 13.1493 2.46267 12.7043 2.2783C12.2593 2.09392 11.7824 1.99902 11.3007 1.99902C10.8191 1.99902 10.3421 2.09392 9.89716 2.2783C9.45219 2.46267 9.0479 2.73291 8.7074 3.07357L8.00073 3.78024L7.29406 3.07357C6.60627 2.38578 5.67342 1.99938 4.70073 1.99938C3.72804 1.99938 2.79519 2.38578 2.1074 3.07357C1.4196 3.76137 1.0332 4.69422 1.0332 5.66691C1.0332 6.6396 1.4196 7.57245 2.1074 8.26024L8.00073 14.1536L13.8941 8.26024C14.2347 7.91974 14.505 7.51545 14.6893 7.07048C14.8737 6.6255 14.9686 6.14857 14.9686 5.66691C14.9686 5.18525 14.8737 4.70831 14.6893 4.26334C14.505 3.81836 14.2347 3.41408 13.8941 3.07357Z"
                    stroke="#332C26" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                {{ forum.likes_count || 0 }}
              </span>

              <span class="forum__meta-item">
                <!-- Ícono comentario (respuestas) -->
                <svg class="forum__icon" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path
                    d="M14 7.66669C14.0023 8.5466 13.7967 9.41461 13.4 10.2C12.9296 11.1412 12.2065 11.9328 11.3116 12.4862C10.4168 13.0396 9.3855 13.3329 8.33333 13.3334C7.45342 13.3356 6.58541 13.1301 5.8 12.7334L2 14L3.26667 10.2C2.86995 9.41461 2.66437 8.5466 2.66667 7.66669C2.66707 6.61452 2.96041 5.58325 3.51381 4.68839C4.06722 3.79352 4.85884 3.0704 5.8 2.60002C6.58541 2.20331 7.45342 1.99772 8.33333 2.00002H8.66667C10.0562 2.07668 11.3687 2.66319 12.3528 3.64726C13.3368 4.63132 13.9233 5.94379 14 7.33335V7.66669Z"
                    stroke="#332C26" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                {{ forum.comments_count || 0 }}
              </span>
            </div>

          </div>
        </div>
      </li>
    </ul>
  </div>
</div>


<ng-template #loadingForums>
  <loading-dots-modal-component></loading-dots-modal-component>
</ng-template>

<ng-template #emptyForums>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <p i18n class="text-center"><strong>No hay entradas en el foro aún.</strong></p>
        <p i18n class="text-center">¡Sé el primero en iniciar una conversación en la comunidad Bhavani!</p>
      </div>
    </div>
  </div>
</ng-template>